import React, { useState } from "react"
import styled from "styled-components"
import Modal from "../../../../_components/Modal"
import Button from "../../../../_components/Button"
import Text from "../../../../_components/Text"
import LoadingInput from "../../../../_components/LoadingInput"
import { FormControl } from "react-bootstrap"
import DatePicker from "react-datepicker"
import moment from 'moment/moment'
import PaymentCostCenter from "../PaymentCostCenter"
import PaymentCategory from "../PaymentCategory"
import { getPaymentMethods } from "../../../../api/payments"
import IconButton from "../../../../_components/IconButton"
import { getClients } from "../../../../api/clients"
import { getSuppliers } from "../../../../api/suppliers"
import AutoComplete from "../AutoComplete"
import translations from "../languages"

const Container = styled.div`
    display: flex
    flex-direction: row
    justify-content: space-between
    @media(max-width: 700px){
        flex-direction: column
        justify-content: space-between
    }
`


export default props => {

    const defaultData = {
        type: props.type
    }

    const [showModal, setShowModal] = React.useState(false)
    const [params, setParams] = React.useState(defaultData)
    const [loading, setLoading] = React.useState(false)
    const [paymentMethodsList, setPaymentMethodsList] = React.useState([])
    const [language, setLanguage] = React.useState('pt')

    const international = translations[language];

    async function getPaymentMethodsList() {
        setLoading(true)
        await getPaymentMethods()
            .then(paymentMethods => {
                setPaymentMethodsList(paymentMethods)
            })
            .finally((() => setLoading(false)))
    }

    function closeModal() {
        setShowModal(false)
    }
    function openModal() {
        setShowModal(true)
    }
    function onChange(e) {
        const { name, value } = e.target
        let tempData = { ...params }

        if (!value) {
            delete tempData[name]
        } else {
            tempData[name] = value
        }
        setParams(tempData)
    }
    function setDate(e) {
        const { name, value } = e.target
        setParams({
            ...params,
            [name]: value
        })
    }
    function onSearch() {
        closeModal()
        if (props.search) {
            props.search(params)
        }
    }

    function init() {
        setTimeout(() => {
            getPaymentMethodsList()
        }, 1000)
        return () => { }
    }

    React.useEffect(init, [])

    return <React.Fragment>

        <Button disabled={props.disabled} onClick={openModal}>
            <IconButton icon="filter" className='text-light' />
        </Button>
        <Modal onHide={closeModal} show={showModal} title={`Pesquisar Conta a ${props.type == 2 ? 'Pagar' : 'Receber'}`}>
            <Container>
                <div className="row col-12" >
                    <div className="col-lg-4 col-sm-12 mb-3">
                        <Text className='text-success'>
                            Situação
                        </Text>
                        <FormControl
                            loading={loading}
                            name="status"
                            onChange={onChange}
                            as="select" >
                            <option value=''>Todos</option>
                            <option selected={params.status == 1} value='1'>{props.type == 1 ? "A Receber" : "A Pagar"}</option>
                            <option selected={params.status == 2} value='2'>{props.type == 1 ? "Recebido" : "Pago"}</option>
                            <option selected={params.status == 3} value='3'>Cancelado</option>
                        </FormControl>
                    </div>
                    <div className="col-lg-4 col-sm-12 mb-3">
                        <Text className='text-success'>
                            Metódo de Pagamento
                        </Text>
                        <FormControl
                            loading={loading}
                            name="payment_method"
                            value={params.payment_method}
                            onChange={onChange}
                            as="select" >
                            <option value=''>Selecionar</option>
                            {paymentMethodsList.map((method, _) => {
                                return <option key={"select_method_" + _} value={method.id}>
                                    {method.name}
                                </option>
                            })}
                        </FormControl>
                    </div>
                    <div className="col-lg-4 col-sm-12 mb-3">
                        <Text className='text-success'>
                            Exibir:
                        </Text>
                        <FormControl
                            loading={loading}
                            name="end_count"
                            value={params.description}
                            onChange={onChange}
                            as="select">
                            {[10, 20, 50, 100, 200].map((count, _) => {
                                return <option key={"select_end_count_" + _} value={count}>
                                    {count}
                                </option>
                            })}
                        </FormControl>
                    </div>
                    <div className="col-lg-4 col-sm-12 mb-3">
                        <Text className='text-success'>
                            Descrição
                        </Text>
                        <FormControl
                            loading={loading}
                            name="description"
                            placeholder='Descrição para buscar'
                            value={params.description}
                            onChange={onChange} />
                    </div>
                    <div className="col-lg-4 col-sm-12 mb-3">
                        <PaymentCostCenter title={international.paymentsOut.modalFields.costCenter} onChange={onChange} />
                    </div>
                    <div className="col-lg-4 col-sm-12 mb-3">
                        <PaymentCategory title={international.paymentsOut.modalFields.category} onChange={onChange} />
                    </div>

                    <div className="col-lg-6 col-sm-12 mb-3">
                        <Text className='text-success'>
                            inicio do Intervalo do Criação
                        </Text>
                        <LoadingInput
                            name="start_created_date"
                            onChange={setDate}
                            value={params.start_created_date}
                            type="date"
                        />
                    </div>
                    <div className="col-lg-6 col-sm-12 mb-3">
                        <Text className='text-success'>
                            Fim do Intervalo de Criação
                        </Text>
                        <LoadingInput
                            name="end_created_date"
                            onChange={setDate}
                            value={params.end_created_date}
                            type="date"
                        />
                    </div>

                    <div className="col-lg-6 col-sm-12 mb-3">
                        <Text className='text-success'>
                            inicio do Intervalo do Vencimento
                        </Text>
                        <LoadingInput
                            name="start_due_date"
                            onChange={setDate}
                            value={params.start_due_date}
                            type="date"
                        />
                    </div>
                    <div className="col-lg-6 col-sm-12 mb-3">
                        <Text className='text-success'>
                            Fim do Intervalo de Vencimento
                        </Text>
                        <LoadingInput
                            name="end_due_date"
                            onChange={setDate}
                            value={params.end_due_date}
                            type="date"
                        />

                    </div>

                    <div className="col-lg-6 col-sm-12 mb-3">

                        <Text color='primary'>
                            {props.type == 1 ? 'Cliente:' : "Fornecedor:"}
                        </Text>
                        <AutoComplete
                            request={props.type == 1 ? getClients : getSuppliers}
                            searchField='name'
                            labelField='name'
                            valueField='original_id'
                            onSelect={e => onChange({ target: { name: 'recipient', value: e.value } })}
                        />

                    </div>

                </div>

            </Container>
            <hr />
            <div className="d-flex justify-content-end">
                <Button
                    disabled={loading}
                    onClick={onSearch}>
                    Pesquisar
                </Button>
            </div>
        </Modal>
    </React.Fragment>
}

function FormGroup(props) {
    return <div className="form-group">
        <div className="form-label">
            {props.label}
        </div>
        <LoadingInput
            loading={props.loading}
            value={props.value}
            name={props.name}
            onChange={props.onChange} />
    </div>
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/Filters/index.jsx